import React, { memo } from "react";
import classnames from "classnames/dedupe";
import { useTranslation } from "react-i18next";

import Style from "./typography.module.scss";

type TTypographySize = "xs" | "s" | "m" | "l" | "xl" | "2xl" | "3xl";
type TTypographyWeight = "regular" | "medium" | "semi-bold" | "bold";
type TTypographyTag = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";
type TTypographyAlign = "center" | "left" | "right";

type TTypographyProps = {
    text: string;
    tag: TTypographyTag;
    size?: TTypographySize;
    weight?: TTypographyWeight;
    color?: string;
    align?: TTypographyAlign;
    className?: string;
};

const Typography = ({ text, tag, size, weight, color, align, className }: TTypographyProps) => {
    const { t } = useTranslation();

    const typographyStyle = classnames(
        Style.typography,
        size && Style[`size-${size}`],
        weight && Style[`weight-${weight}`],
        align && Style[`align-${align}`],
        color && Style[color],
        className // only pass global className
    );

    const Tag = tag as keyof JSX.IntrinsicElements;

    return <Tag className={typographyStyle}>{t(text)}</Tag>;
};

export default memo(Typography);
